import { Injectable } from '@angular/core';
import { HttpGeneralService } from '../../shared/http-general.service';
import { IPromotionStp, IPromotionsMsgLog, IServiceProviderSetting, IPromotionMsgLogParms, MsgTemplate, SmsSendSetting } from '../promotions';
import { CONFIG } from '../../shared/config';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
let callCenterReservation = CONFIG.baseUrls.emergencyReservation;

let smsMessageUrl = CONFIG.baseUrls.SmsMessage;

@Injectable({
  providedIn: 'root'
})
export class SmsService {
  constructor(private _httpGeneralService: HttpGeneralService, private _http: HttpClient) { }
  //amerhashima 12/1/2022
  ConfirmationRegisterationMsg(logs: IPromotionsMsgLog[]) {
    return this._httpGeneralService.add<IPromotionsMsgLog[]>(logs, `${smsMessageUrl}/RemindingBookingMsg`);
  }

  RemindingBookingMsg(data: IPromotionsMsgLog[]) {
    return this._httpGeneralService.add<IPromotionsMsgLog[]>(data, `${smsMessageUrl}/RemindingBookingMsg`);
  }

  SendSmsData(data: SmsSendSetting) {
    return this._httpGeneralService.add(data, `${smsMessageUrl}/SendSmsData`);
  }
  getMsgTemplate(getMsgTemplate: MsgTemplate) {
    getMsgTemplate.moduleId = 10123
    return this._httpGeneralService.add(getMsgTemplate, `${callCenterReservation}/SendTemplateMsg`);
  }

  replaceSmSMsgData(replaceDataObj: any, MsgTemplate: string) {
    let Msg: string
    let date
    // if (replaceDataObj) {
    //   if (replaceDataObj.reservationDate) {
    //     let event = new Date(replaceDataObj.reservationDate);
    //     let dayName = event.toLocaleDateString('ar-EG', { weekday: 'long' });
    //     let formattedDate = event.toISOString().slice(0, 16).replace('T', ' الساعة ');
    //     date = `${dayName} ${formattedDate}`;
    //     // Msg = MsgTemplate.replace('{{this.reservationDate}}', date)
    //   }
    if (replaceDataObj) {
      if (replaceDataObj.reservationDate) {
        let event = new Date(replaceDataObj.reservationDate);
        let dayName = event.toLocaleDateString('ar-EG', { weekday: 'long' });
        let formattedDate = event.toLocaleString('ar-EG', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
          timeZone: 'Africa/Cairo'
        });

        date = `${dayName} الساعة ${formattedDate}`;
        // Msg = MsgTemplate.replace('{{this.reservationDate}}', date)
      }
      Msg = MsgTemplate.replace('{{this.reservationDate}}', date ? date : '')
        .replace('{{this.doctorName}}', replaceDataObj.doctorName ? replaceDataObj.doctorName : '')
        .replace('{{this.shortDoctorName}}', replaceDataObj.shortDoctorName ? replaceDataObj.shortDoctorName : '')
        .replace('{{this.deviceName}}', replaceDataObj.deviceName ? replaceDataObj.deviceName : '')
        .replace('{{this.patientName}}', replaceDataObj.patientName ? replaceDataObj.patientName : '')
        .replace('{{this.clinicName}}', replaceDataObj.clinicName ? replaceDataObj.clinicName : '')
        .replace('{{this.patientArrangement}}', replaceDataObj.patientArrangement ? replaceDataObj.patientArrangement : '')
        .replace('{{this.patientWaiting}}', replaceDataObj.patientWaiting ? replaceDataObj.patientWaiting : '')
        .replace('{{this.labName}}', replaceDataObj.labName ? replaceDataObj.labName : '')
    }

    return Msg
  }

  sendFile(file: File, recipientPhone: string, caption: string): Observable<any> {
    return new Observable(observer => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64File = reader.result?.toString().split(',')[1];
        const payload = {
          File: base64File,
          Mobile: recipientPhone,
          Caption: caption,
          FileName: file.name
        };

        this._httpGeneralService.post(payload, `${smsMessageUrl}/WhatsAppSentFile`)
          .subscribe({
            next: (response) => {
              observer.next(response);
              observer.complete();
            },
            error: (error) => {
              observer.error(error);
            }
          });
      };
      reader.onerror = error => observer.error(error);
    });
  }

}
